import React from 'react';
import { AvatarSizeTokens, BorderRadiusTokens, ButtonTypeTokens, ColorTokens, IconAlignmentTokens, IconTokens, LikeStateTokens, SizeTypeTokens, StackAlignItems, StackType, TypographyTypeTokens, } from '@voltmoney/schema';
import { TouchableOpacity } from 'react-native';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Avatar from '../avatar/Avatar';
import { Button } from '../button/Button';
const CommentCard = ({ user, padding = {
    vertical: SizeTypeTokens.MD,
    horizontal: SizeTypeTokens.MD,
}, margin, title, time, bgColor = ColorTokens.Grey_600, onPressProfile, profileAction, likeAction, onPressLike, likeState = LikeStateTokens.NOT_SELECTED, likeCount, triggerAction, }) => {
    if (!title)
        return React.createElement(React.Fragment, null);
    else
        return (React.createElement(Card, { margin: margin, padding: {
                vertical: SizeTypeTokens.NONE,
                horizontal: SizeTypeTokens.NONE,
            }, header: {
                children: (React.createElement(Card, { bgColor: bgColor, borderRadius: BorderRadiusTokens.BR1, padding: padding, header: {
                        children: (React.createElement(React.Fragment, null,
                            React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                                React.createElement(TouchableOpacity, { onPress: () => {
                                        if (profileAction)
                                            triggerAction(profileAction);
                                        if (onPressProfile)
                                            onPressProfile();
                                    }, style: {
                                        maxWidth: '85%',
                                    } },
                                    React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                                        React.createElement(Avatar, { uri: user?.avatar, size: AvatarSizeTokens.XS }),
                                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                                        React.createElement(Typography, { label: user?.title, numberOfLines: 1, type: TypographyTypeTokens.S5 }))),
                                React.createElement(Space, { size: SizeTypeTokens.MD }),
                                time ? (React.createElement(Typography, { label: time, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_200 })) : (React.createElement(React.Fragment, null))),
                            React.createElement(Space, { size: SizeTypeTokens.MD }),
                            React.createElement(Typography, { label: title }))),
                    } })),
            }, footer: {
                children: [
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Button, { type: ButtonTypeTokens.SmallGhost, labelColor: ColorTokens.Grey_50, icon: {
                            name: likeState === LikeStateTokens.SELECTED
                                ? IconTokens.LikeFilled
                                : IconTokens.Like,
                            align: IconAlignmentTokens.left,
                        }, label: likeCount, onPress: () => {
                            if (likeAction)
                                triggerAction(likeAction);
                            if (onPressLike)
                                onPressLike();
                        } }),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                ],
            } }));
};
export default React.memo(CommentCard);
export { CommentCard };
